import {gsap} from 'gsap';

const heroAInit = () => {
  // Hero Animation
  const tl = gsap.timeline({id: 'heroA'});

  tl.from('[data-element="hero-a-shape-top"]', {
    autoAlpha: 0,
    delay: 0.3,
    duration: 0.5,
    y: '-100%',
  }).from('[data-element="hero-a-shape-bottom"]', {
    autoAlpha: 0,
    duration: 0.5,
    y: '100%',
  },
  '<'
  ).from(
    '[data-element="hero-a-text"]',
    {
      autoAlpha: 0,
      y: '-16',
    }
  ).from(
    '[data-element="hero-a-img"]',
    {
      autoAlpha: 0,
      duration: 0.3,
      y: 16,
    },
    '<'
  ).from(
    '[data-element="hero-a-shape"]',
    {
      autoAlpha: 0,
      scale: 0,
      duration: 0.5,
    },
    '<'
  );
};

const heroBInit = () => {
  // Hero Animation
  const tl = gsap.timeline({id: 'heroB'});

  tl.from(
    '[data-element="hero-b-img"]',
    {
      autoAlpha: 0,
      delay: 0.3,
      duration: 0.3,
      y: 16,
    }
  ).from(
    '[data-element="hero-b-shape"]',
    {
      autoAlpha: 0,
      scale: 0,
      duration: 0.2,
    },
    '-=0.2'
  ).from(
    '[data-element="hero-b-text"]',
    {
      autoAlpha: 0,
      y: '-16',
    },
    '-=0.2'
  );
};

const heroCInit = () => {
  // Hero Animation
  const tl = gsap.timeline({id: 'heroC'});

  tl.from('[data-element="hero-c-shape-top"]', {
    autoAlpha: 0,
    delay: 0.3,
    duration: 0.5,
    y: '-100%',
  }).from('[data-element="hero-c-shape-middle"]', {
    autoAlpha: 0,
    duration: 0.5,
    x: '-100%',
  },
  '<'
  ).from('[data-element="hero-c-shape-bottom"]', {
    autoAlpha: 0,
    duration: 0.5,
    y: '100%',
  },
  '<'
  ).from(
    '[data-element="hero-c-text"]',
    {
      autoAlpha: 0,
      y: '-16',
    }
  ).from(
    '[data-element="hero-c-img"]',
    {
      autoAlpha: 0,
      duration: 0.3,
      y: 16,
    },
    '<'
  );
};

const heroCircleInit = () => {
  const tl = gsap.timeline({id: 'heroCircle'});

  tl.from(
    '[data-element="hero-circle"]',
    {
      delay: 0.3,
      duration: 0.5,
      scale: 0.8,
      transformOrigin: 'center',
    }
  ).from(
    '[data-element="hero-circle-mask"]',
    {
      duration: 0.3,
      scale: 0.8,
      transformOrigin: 'center',
    },
    '<0.2'
  ).from(
    '[data-element="hero-circle-bg"]',
    {
      duration: 0.3,
      scale: 0.8,
      transformOrigin: 'center',
    },
    '<'
  ).from(
    '[data-element="hero-circle-text"]',
    {
      autoAlpha: 0,
      y: '-16',
    }
  ).from(
    '[data-element="hero-circle-img"]',
    {
      autoAlpha: 0,
      y: 16,
    },
    '<'
  );
};

const heroTrapezoidInit = () => {
  // Hero Animation
  const tl = gsap.timeline({id: 'heroTrapezoid'});

  tl.from('[data-element="hero-trapezoid-shape-top"]', {
    autoAlpha: 0,
    delay: 0.3,
    duration: 0.5,
    y: '-100%',
  }).from('[data-element="hero-trapezoid-shape-middle"]', {
    autoAlpha: 0,
    duration: 0.5,
    x: '-100%',
  },
  '<'
  ).from('[data-element="hero-trapezoid-shape-bottom"]', {
    autoAlpha: 0,
    duration: 0.5,
    y: '100%',
  },
  '<'
  ).from(
    '[data-element="hero-trapezoid-text"]',
    {
      autoAlpha: 0,
      y: '-16',
    }
  ).from(
    '[data-element="hero-trapezoid-img"]',
    {
      autoAlpha: 0,
      duration: 0.3,
      y: 16,
    },
    '<'
  );
};

const heroAnimations = {
  init() {
    const heroA = document.querySelector('[data-module="hero-a-animation"]');
    const heroB = document.querySelector('[data-module="hero-b-animation"]');
    const heroC = document.querySelector('[data-module="hero-c-animation"]');
    const heroCircle = document.querySelector('[data-module="hero-circle-animation"]');
    const heroTrapezoid = document.querySelector('[data-module="hero-trapezoid-animation"]');

    if (heroA) {
      heroAInit();
    }

    if (heroB) {
      heroBInit();
    }

    if (heroC) {
      heroCInit();
    }

    if (heroCircle) {
      heroCircleInit();
    }

    if (heroTrapezoid) {
      heroTrapezoidInit();
    }
  },
};

export default heroAnimations;
